module.exports = __webpack_public_path__ + "img/trainingsschema-week-1-5.df0ec14c.png";